import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo">
          <NavLink to="/" onClick={closeMenu}>София World</NavLink>
        </div>
        <button className="menu-toggle" onClick={toggleMenu}>
          <span className={`menu-icon ${menuOpen ? 'open' : ''}`}></span>
        </button>
        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink to="/" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Главная
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Обо мне
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/gallery" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Фотогалерея
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/astrology" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Астрология
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/parents" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Родители
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/wishlist" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Вишлист
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/events" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                События
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/diary" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Дневник
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/guestbook" onClick={closeMenu} className={({ isActive }) => isActive ? 'active' : ''}>
                Книга пожеланий
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header; 